export default __webpack_public_path__ + "static/media/ShellFloorPlan.668a34e5.svg";